import { FormValidations } from "features/shared/forms/hooks/useForm";

export const productFormValidations = (): FormValidations  => {
  return {
    productCode: {
      required: true,
      type: "OnlyRequired",
      requiredMessage: "productFormValidation.productCode"
    }
  };
}